import { render } from "./SamplesRequest.vue?vue&type=template&id=743dac20"
import script from "./SamplesRequest.vue?vue&type=script&lang=js"
export * from "./SamplesRequest.vue?vue&type=script&lang=js"

import "./SamplesRequest.vue?vue&type=style&index=0&id=743dac20&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__